import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { logErrorFromMicroservicesSdk } from '@sxm-de/dev-kits/web-sdk/utils';

interface VerifyAccountLpzFnPayload {
    lastName: string;
    phoneNumber: string;
    zipCode: string;
}

export type VerifyAccountLpzFn = (
    payload: VerifyAccountLpzFnPayload,
) => Promise<boolean>;

export function initVerifyAccountLpzFn({
    dependencies,
}: DomainInitPayload): VerifyAccountLpzFn {
    const { microservicesSdk } = dependencies;
    return async ({
        lastName,
        phoneNumber,
        zipCode,
    }: VerifyAccountLpzFnPayload) => {
        try {
            return await microservicesSdk.domains.account.verify({
                lastName,
                phoneNumber,
                zipCode,
            });
        } catch (error: any) {
            logErrorFromMicroservicesSdk(error, dependencies);
            throw new Error('SYSTEM');
        }
    };
}
